import { CountdownTimer } from "./CountdownTimer";
import { ChevronRight, BadgeCheck } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/54c96657-99e1-4d83-ad02-a9619978663f/images/1bec4a9fadb3a39fca02b89981d543188f8785db4e818dc94a2697015e3f8d01.png";

const PRODUCT_MOCKUP =
  "https://static.prod-images.emergentagent.com/jobs/54c96657-99e1-4d83-ad02-a9619978663f/images/ba2fca9f63eac3735cc6b085c9e1b312782080b843327895a174e5e99b62e884.png";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative bg-[#0A192F] overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(10,25,47,0.88), rgba(10,25,47,0.95)), url(${HERO_BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 hero-grid opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16 sm:py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Copy */}
          <div className="fade-up">
            <div className="flex items-center gap-3 mb-6">
              <div className="gold-divider" />
              <span className="font-accent text-[#C5A059] text-xs">
                FOUNDER'S LAUNCH &middot; 53% OFF
              </span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6"
            >
              Be Your Own Boss.
              <br />
              <span className="text-[#C5A059] italic">Instant business</span> in a box.
            </h1>

            <p className="text-white/80 text-base sm:text-lg leading-relaxed mb-10 max-w-xl">
              Investor-ready business plans for 5 high-demand industries &mdash;
              complete with 3-year financial projections, curricula, and SWOT analysis.
              Delivered instantly as a downloadable PDF.
            </p>

            <div className="mb-10">
              <div className="font-accent text-white/60 text-[11px] mb-3">
                FOUNDER'S DISCOUNT ENDS IN
              </div>
              <CountdownTimer />
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                data-testid="hero-cta-primary"
                href="#products"
                className="group bg-[#C5A059] hover:bg-[#D4AF37] text-[#0A192F] font-bold px-7 py-4 text-sm inline-flex items-center gap-2 transition shadow-lg shadow-black/30"
              >
                EXPLORE BUSINESS PLANS
                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition" />
              </a>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <BadgeCheck className="w-5 h-5 text-[#C5A059]" />
                Expert-Backed Business Blueprints
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="hidden lg:flex relative justify-center fade-up" style={{ animationDelay: "0.2s" }}>
            <div className="absolute -inset-6 border border-[#C5A059]/30" />
            <img
              src={PRODUCT_MOCKUP}
              alt="AIGL Business Plan Package"
              className="relative w-full max-w-md object-contain"
            />
          </div>
        </div>
      </div>

      {/* Trust bar at bottom of hero */}
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-5 flex flex-wrap gap-x-10 gap-y-3 justify-center sm:justify-between items-center text-white/70 text-[11px] sm:text-xs font-accent">
          <span>INSTANT PDF DELIVERY</span>
          <span className="hidden sm:block">SECURE STRIPE &amp; PAYPAL</span>
          <span>INVESTOR-READY FORMAT</span>
          <span className="hidden sm:block">USED IN 38+ COUNTRIES</span>
          <span>3-YEAR FINANCIAL FORECAST</span>
        </div>
      </div>
    </section>
  );
};
